import { apiMipe } from '@/core/api/';

export const getStudentSchool = async (academicYearId, studentSieId) => {
  return await apiMipe.get(
    `api/student/getstudentschool/${studentSieId}/${academicYearId}`
  );
};

export const getById = (sie) => apiMipe.get(`api/student/${sie}`);
